import { PropsWithChildren } from 'react'

export type ModalUploadProps = PropsWithChildren<{
  dismissable?: boolean
  onClose?: () => void
}>

export type ModalUploadRegisterFunctions = {
  showModal: (params: ModalUploadProps) => void
  hideModal: () => void
}

export class ModalUploadManager {
  modalFunctions: ModalUploadRegisterFunctions | null = null

  static instance: ModalUploadManager

  static getInstance() {
    if (!ModalUploadManager.instance) {
      ModalUploadManager.instance = new ModalUploadManager()
    }
    return ModalUploadManager.instance
  }

  static register(functions: ModalUploadRegisterFunctions) {
    ModalUploadManager.getInstance().modalFunctions = functions
  }
  static show(params: ModalUploadProps) {
    ModalUploadManager.getInstance()?.modalFunctions?.showModal({ ...params })
  }

  static hide() {
    ModalUploadManager.getInstance()?.modalFunctions?.hideModal()
  }
}
